(function()
{
	//Import classes
	var BasePanel = include('springroll.easeljs.BasePanel'),
		Text = include('createjs.Text'),
		Delay = include('springroll.DelayedCall'),
		Container = include('createjs.Container');

	/**
	 * Panel contains all of the visual elements for the Game state
	 * @class Lemonade.OutsidePanel
	 * @extends springroll.easeljs.BasePanel
	 */
	var OutsidePanel = function()
	{
		BasePanel.call(this);

		this.setupRound = this.setupRound.bind(this);
		this.playIntroSequence = this.playIntroSequence.bind(this);
		this.playCorrectAnim = this.playCorrectAnim.bind(this);
		this.playTooFewAnimation = this.playTooFewAnimation.bind(this);
		this.playTooManyAnimation = this.playTooManyAnimation.bind(this);
		this.playFinalIncorrect = this.playFinalIncorrect.bind(this);
		this.setCorrectNumberOfCups = this.setCorrectNumberOfCups.bind(this);
		this.playAnimationSequence = this.playAnimationSequence.bind(this);
		this.advanceSequence = this.advanceSequence.bind(this);
		this.showOKButton = this.showOKButton.bind(this);
		this.highlightPitcher = this.highlightPitcher.bind(this);
		this.highlightOk = this.highlightOk.bind(this);
	};

	//Super prototype
	var s = BasePanel.prototype;

	//Extend the base panel
	var p = extend(OutsidePanel, BasePanel);

	/**
	 * Setup the state, this happens on each state entering
	 */
	p.setup = function()
	{
		this.state = app.states.outside;

		this.sceneLib = app.globalState.language == "en" ? lib_outside : lib_outside_es;
		this.skin = new this.sceneLib[app.globalState.language == "en" ? "Outside" : "Outside_sp"]();
		this.skin._updateTimeline();
		this.addChild(this.skin);

		// Setup characters
		this.groverLib = app.globalState.language == "en" ? lib_grover : lib_grover_es;
		this.groverContainer = this.skin.grover_container;
		this.grover = null;
		this.currentRig = null;
		this.groverList = {
			"intro" : "_1_grover_intro",
			"cupcount" : "_3_grover_cupcount",
			"wrongchoice_few" : "_4_grover_wrongchoice_1",
			"wrongchoice_final" : "_4_grover_wrongchoice_2",
			"wrongchoice_many" : "_4_grover_wrongchoice_3",
			"correct" : "_5_grover_correct",
			"timeout" : "_7_grover_timeout"
		};

		// animation sequencing vars
		this.currentSequence = null;
		this.sequenceCallback = null;
		this.sequenceStage = -1;
		/*
		{
			char: "Grover",
			anim: "Intro_1",
			onPlay: null,
			rig: "intro"
		},
		*/

		this.elmo = this.skin.elmo;
		this.elmo.framerate = 31;
		this.elmo.stop();

		this.pitcher = this.skin.pitcher;
		this.pitcher.stop();
		this.pitcher.highlight.alpha = 0;

		this.jar = this.skin.jar;
		this.jar.stop();
		this.jar._updateTimeline();
		this.jar.label._updateTimeline();
		this.jar.label.gotoAndStop(app.globalState.causes[app.globalState.currentCause].item_name);

		this.cups = this.skin.cups;
		this.cups.stop();

		this.upclose = this.skin.upclose;
		this.upclose.jar.framerate = 31;
		this.upclose.jar.stop();
		this.upclose._updateTimeline();
		this.upclose.jar._updateTimeline();
		this.upclose.jar.label._updateTimeline();
		this.upclose.jar.label.gotoAndStop(app.globalState.causes[app.globalState.currentCause].item_name);
		this.upclose.visible = false;

		this.counter = new this.sceneLib.counter();
		this.counter.stop();
		this.addChild(this.counter);

		this.ok = this.skin.ok;
		this.ok.highlight.alpha = 0;
		this.ok.initialScale = {
			x: this.ok.scaleX,
			y: this.ok.scaleY
		};

		this.singleMonsters = [
			{
				name: "monster4",
				intro: "SL_cor_cust_line1a",
				outro: "SL_cor_cust_line1b",
				gameObject: null
			},
			{
				name: "monster6",
				intro: "SL_cor_cust_line1c",
				outro: "SL_cor_cust_line1b",
				gameObject: null
			},
			{
				name: "monster7",
				intro: "SL_cor_cust_line1a",
				outro: "SL_cor_cust_line1b",
				gameObject: null
			}
		];
		this.groupMonsters = [
			{
				name: "monster1",
				intro: "SL_cor_cust_line5a",
				outro: "SL_cor_cust_line5b",
				gameObject: null
			},
			{
				name: "monster2",
				intro: "SL_cor_cust_line2a",
				outro: "SL_cor_cust_line2b",
				gameObject: null
			},
			{
				name: "monster3",
				intro: "SL_cor_cust_line3a",
				outro: "SL_cor_cust_line3b",
				gameObject: null
			},
			{
				name: "monster5",
				intro: "SL_cor_cust_line4a",
				outro: "SL_cor_cust_line4b",
				gameObject: null
			}
		];

		// track monsters we have already used
		this.monstersUsed = [];

		this.monsterStartPos = {
			x: 620,
			y: 750
		};
		this.monsterPlacementSpace = 540;
		this.monsterSpacing = 90; // recalculated each round
		this.currentMonsters = [

		];

		this.gtmTimeoutStart = -1;

		this.setupRound();
	};

	p.setupRound = function() {
		var i, custName, newCust;

		this.state.customerCount = app.getRandomInt(1, 5);
		this.setGroverRig("intro");

		this.ok.scaleX = this.ok.scaleY = 0;
		this.ok.visible = false;

		// destroy previous monsters
		this.currentMonsters = [];

		if (this.state.customerCount == 1) {
			// set spacing
			this.monsterSpacing = this.monsterPlacementSpace / 2;

			// use a monster with singular VO
			var nextSingleMonster = app.randFromArray(this.singleMonsters);
			while (this.monstersUsed.indexOf(nextSingleMonster.name) > -1) {
				nextSingleMonster = app.randFromArray(this.singleMonsters);
			}

			this.monstersUsed.push(nextSingleMonster.name);
			this.currentMonsters.push(nextSingleMonster);

			custName = this.currentMonsters[0].name;
			// custName = "monster_placeholder";
			newCust = this.generateCustomer(custName, 0);
			this.skin.customers.addChildAt(newCust, 0);
			this.currentMonsters[0].gameObject = newCust;
		} else {
			// calculate spacing
			this.monsterSpacing = this.monsterPlacementSpace / (this.state.customerCount + 1);
			// generate all the monsters
			app.shuffle(this.groupMonsters);
			for (i = 0; i < this.state.customerCount; i++) {
				
				if (i === 0) {
					// make sure we have not used this monster yet
					var nextMonster = this.groupMonsters[0];
					while (this.monstersUsed.indexOf(nextMonster.name) > -1) {
						// shuffle and try again
						app.shuffle(this.groupMonsters);
						nextMonster = this.groupMonsters[0];
					}
					
					this.monstersUsed.push(nextMonster.name);
					this.currentMonsters.push(nextMonster);
				} else if (i < this.groupMonsters.length) {
					this.currentMonsters.push(this.groupMonsters[0]);
				} else {
					this.currentMonsters.push(this.singleMonsters[0]);
				}
				custName = this.currentMonsters[i].name;
				// custName = "monster_placeholder";
				newCust = this.generateCustomer(custName, i);
				this.skin.customers.addChildAt(newCust, 0);
				this.currentMonsters[i].gameObject = newCust;

				this.groupMonsters.push(this.groupMonsters.shift());
			}
		}
	};

	p.playIntroSequence = function() {
		var newSequence = [
			{
				char: this.grover,
				anim: app.config.animations.Grover["Sell_Intro_" + this.state.currentRound],
				onPlay: null,
				rig: "intro"
			},
			{
				char: this.currentMonsters[0].gameObject,
				anim: [
					{
						anim: this.currentMonsters[0].intro,
						audio: this.currentMonsters[0].intro
					}
				],
				onPlay: null
			},
			{
				char: this.grover,
				anim: app.config.animations.Grover["Sell_Instrux_" + (this.currentMonsters.length > 1 ? "Multi" : "Single") + "_1"],
				onPlay: this.state.currentRound > 1 ? this.showOKButton : function() {
					this.highlightPitcher(this.currentMonsters.length > 1 ? 7500 : 3000);
				}.bind(this), // show button early on sub play
				rig: "intro"
			},
			{
				char: this.grover,
				anim: app.config.animations.Grover["Sell_Instrux_" + (this.currentMonsters.length > 1 ? "Multi" : "Single") + "_2"],
				onPlay: this.state.currentRound === 1 ? this.showOKButton : null,
				rig: "intro"
			}
		];

		app.animator.play(this.elmo, "idle");

		this.playAnimationSequence(newSequence, this.state.currentRound === 1 ? this.state.onRoundIntroComplete : this.state.startTimeout);
	};

	p.playCountAnim = function(cups) {
		this.cups.gotoAndStop(cups);
		this.counter.gotoAndStop(cups);

		var newSequence = [
			{
				char: this.grover,
				anim: app.config.animations.Grover["Count_" + cups],
				onPlay: null,
				rig: "cupcount"
			}
		];

		this.playAnimationSequence(newSequence);
	};

	p.playCorrectAnim = function() {
		var newSequence;

		if (this.currentMonsters.length > 1) {
			// multi monster CA
			newSequence = [
				{
					char: this.grover,
					anim: app.config.animations.Grover.Correct_1_Multi,
					onPlay: null,
					rig: "correct"
				},
				{
					char: this.grover,
					anim: app.config.animations.Grover["Correct_Total_" + this.currentMonsters.length],
					onPlay: null,
					rig: "correct"
				},
				{
					char: this.grover,
					anim: app.config.animations.Grover.Correct_Thanks,
					onPlay: null,
					rig: "correct"
				},
				{
					char: this.elmo,
					anim: app.config.animations.Elmo.Selling_Correct,
					onPlay: null
				}
			];
		} else {
			// single monster CA
			newSequence = [
				{
					char: this.grover,
					anim: app.config.animations.Grover.Correct_1_Single,
					onPlay: null,
					rig: "correct"
				},
				{
					char: this.grover,
					anim: app.config.animations.Grover.Correct_Thanks,
					onPlay: null,
					rig: "correct"
				},
				{
					char: this.elmo,
					anim: app.config.animations.Elmo.Selling_Correct,
					onPlay: null
				}
			];
		}

		this.playAnimationSequence(newSequence, this.state.onRoundSuccess);
	};

	p.playTooFewAnimation = function(count) {
		var newSequence;

		switch (count) {
			case 1:
				newSequence = [
					{
						char: this.grover,
						anim: app.config.animations.Grover.NotEnough_1,
						onPlay: function(){
							this.highlightPitcher(3100);
						}.bind(this),
						rig: "wrongchoice_few"
					}
				];
			break;
			case 2: 
				newSequence = [
					{
						char: this.grover,
						anim: app.config.animations.Grover.NotEnough_2,
						onPlay: function(){
							this.highlightPitcher(8000);
						}.bind(this),
						rig: "wrongchoice_few"
					}
				];
			break;
			case 3:
				if (this.currentMonsters.length > 1) {
					newSequence = [
						{
							char: this.grover,
							anim: app.config.animations.Grover.NotEnough_3_Multi,
							onPlay: null,
							rig: "wrongchoice_few"
						},
						{
							char: this.grover,
							anim: app.config.animations.Grover["Cups_" + (this.state.customerCount - this.state.cupCount)],
							onPlay: null,
							rig: "cupcount"
						}
					];
				} else {
					newSequence = [
						{
							char: this.grover,
							anim: app.config.animations.Grover.NotEnough_3_Single,
							onPlay: function(){
								this.highlightPitcher(6500);
							}.bind(this),
							rig: "wrongchoice_few"
						}
					];
				}
			break;
			default:
				// this should be a final!!
			break;

		}


		this.playAnimationSequence(newSequence, this.state.onRoundFail);
	};

	p.playTooManyAnimation = function(count) {
		var newSequence;

		switch (count) {
			case 1:
				newSequence = [
					{
						char: this.grover,
						anim: app.config.animations.Grover.TooMany_1,
						onPlay: null,
						rig: "wrongchoice_many"
					}
				];
			break;
			case 2: 
				newSequence = [
					{
						char: this.grover,
						anim: app.config.animations.Grover.TooMany_2,
						onPlay: null,
						rig: "wrongchoice_many"
					}
				];
			break;
			case 3:
				newSequence = [
					{
						char: this.grover,
						anim: app.config.animations.Grover.TooMany_3,
						onPlay: null,
						rig: "wrongchoice_many"
					},
					{
						char: this.grover,
						anim: app.config.animations.Grover["Cups_" + this.state.customerCount],
						onPlay: null,
						rig: "cupcount"
					}
				];
			break;
			default:
				// this should be a final!!
			break;

		}

		this.playAnimationSequence(newSequence, function(){ this.state.onRoundFail(true); }.bind(this) );
	};

	p.playFinalIncorrect = function() {
		var newSequence;

		if (this.currentMonsters.length > 1) {
			// multi monster
			newSequence = [
				{
					char: this.grover,
					anim: app.config.animations.Grover["FinalIncorrect_Multi_" + this.currentMonsters.length],
					onPlay: null,
					rig: "wrongchoice_final"
				},
				{
					char: this.grover,
					anim: app.config.animations.Grover.FinalIncorrect_Multi_Wrapup,
					onPlay: this.setCorrectNumberOfCups,
					rig: "wrongchoice_final"
				},
				{
					char: this.grover,
					anim: app.config.animations.Grover.FinalIncorrect_OK_Prompt,
					onPlay: function(){
						this.highlightOk(0);
					}.bind(this),
					rig: "wrongchoice_final"
				}
			];
		} else {
			newSequence = [
				{
					char: this.grover,
					anim: app.config.animations.Grover.FinalIncorrect_Single,
					onPlay: function(){
						this.setCorrectNumberOfCups(9000);
					}.bind(this),
					rig: "wrongchoice_final"
				},
				{
					char: this.grover,
					anim: app.config.animations.Grover.FinalIncorrect_OK_Prompt,
					onPlay: function(){
						this.highlightOk(0);
					}.bind(this),
					rig: "wrongchoice_final"
				}
			];
		}

		this.playAnimationSequence(newSequence, this.state.onRoundFail);
	};

	p.setCorrectNumberOfCups = function(delay) {
		if (typeof delay === "undefined") {
			delay = 0;
		}
		createjs.Tween.get(this)
			.wait(delay)
			.call(function(){
				this.state.cupCount = this.currentMonsters.length;
				this.cups.gotoAndStop(this.state.cupCount);
				this.counter.gotoAndStop(this.state.cupCount);
			}.bind(this));
	};

	p.playAnimationSequence = function(sequence, callback) {
		app.animator.stop(this.grover);

		this.sequenceStage = -1;
		this.currentSequence = sequence;
		this.sequenceCallback = callback;
		this.advanceSequence();
	};

	p.advanceSequence = function() {
		this.sequenceStage++;
		if (this.sequenceStage >= this.currentSequence.length) {
			if (this.sequenceCallback !== null && typeof this.sequenceCallback !== "undefined") {
				this.sequenceCallback();
			}
			return;
		}

		var nextAnim = this.currentSequence[this.sequenceStage];
		if (typeof nextAnim.rig !== "undefined") {
			// this is a grover animation
			this.setGroverRig(nextAnim.rig);
			this.grover._updateTimeline();
			nextAnim.char = this.grover; // update grover ref
		}

		app.animator.play(
			nextAnim.char,
			nextAnim.anim,
			this.advanceSequence
		);

		if (typeof nextAnim.onPlay == "function") {
			nextAnim.onPlay();
		}
	};

	p.setGroverRig = function(symbolName) {
		if (typeof this.groverList[symbolName] === "undefined") {
			console.log("Could not find key for grover symbol " + symbolName);
			return;
		} else if (this.currentRig === symbolName) {
			// console.log("Already have the correct Grover rig!");
			return;
		}

		if (this.grover !== null) {
			this.groverContainer.removeChild(this.grover);
			this.grover = null;
		}

		this.currentRig = symbolName;
		this.grover = new this.groverLib[this.groverList[symbolName]]();
		this.grover.framerate = 31;
		this.grover.stop();
		// this.grover.scaleX = this.grover.scaleY = 0.767;
		this.groverContainer.addChild(this.grover);
	};

	p.generateCustomer = function(name, count) {
		var customer = new this.sceneLib[name]();
		customer.framerate = 31;
		customer.stop();
		// offset count by one
		customer.x = this.monsterStartPos.x - (this.monsterSpacing * (count + 1));
		customer.y = this.monsterStartPos.y;
		customer.scaleX = customer.scaleY = 1;
		return customer;
	};

	p.clearCustomers = function() {
		for (var i = 0; i < this.currentMonsters.length; i++) {
				
			this.skin.customers.removeChild(this.currentMonsters[i].gameObject);
			this.currentMonsters[i].gameObject = null;
		}
	};

	p.zoomIn = function() {
		this.upclose.visible = true;
		this.counter.visible = false;
	};

	p.zoomOut = function() {
		this.upclose.visible = false;
		this.counter.visible = true;
	};

	p.showOKButton = function(delay) {
		if (typeof delay === "undefined") {
			delay = 2500;
		}
		// show and allow interaction immediately on subs play
		if (this.state.currentRound > 1) {
			delay = 0;
			this.state.bindEvents(); // bind events early
			this.highlightPitcher(this.currentMonsters.length > 1 ? 7500 : 3000); // highlight pitcher, since we are overriding the highlight function to show ok early
		}

		createjs.Tween.get(this.ok)
			.wait(delay)
			.set({visible: true})
			.call(function(){
				app.sound.play("ses-lem_okbutton-appear");
			})
			.to({scaleX: this.ok.initialScale.x, scaleY: this.ok.initialScale.y}, 400, createjs.Ease.backOut);
	};

	p.highlightPitcher = function(delay) {
		if (typeof delay === "undefined") {
			delay = 0;
		}
		createjs.Tween.get(this.pitcher.highlight)
			.wait(delay)
			.call(function(){
				app.sound.play("ses-lem_pitcher-hilite");
			})
			.set({alpha: 1})
			.wait(200)
			.set({alpha: 0})
			.wait(200)
			.set({alpha: 1})
			.wait(200)
			.set({alpha: 0})
			.wait(200)
			.set({alpha: 1})
			.wait(3000)
			.set({alpha: 0});
	};

	p.highlightOk = function(delay) {
		if (typeof delay === "undefined") {
			delay = 2500;
		}
		createjs.Tween.get(this.ok.highlight)
			.wait(delay)
			.call(function(){
				app.sound.play("ses-lem_pitcher-hilite");
			})
			.set({alpha: 1})
			.wait(200)
			.set({alpha: 0})
			.wait(200)
			.set({alpha: 1})
			.wait(200)
			.set({alpha: 0})
			.wait(200)
			.set({alpha: 1})
			.wait(3000)
			.set({alpha: 0});
	};

	/**
	 * Un-setup the panel when exiting the state
	 */
	p.teardown = function()
	{
		s.teardown.call(this);
		this.skin = null;
	};

	//Assign to namespace
	namespace('Lemonade').OutsidePanel = OutsidePanel;
})(lib = lib||{}, images = images||{}, createjs = createjs||{}, ss = ss||{});
var lib, images, createjs, ss;